var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-box"},[_c('div',{staticClass:"bg-image"},[_c('div',{staticClass:"bg-text mt-4 p-5"},[_c('h1',{staticClass:"text-white rounded"},[_vm._v("Travelling Hungry??")]),_c('b-button',{attrs:{"variant":"outline-danger"}},[_c('RouterLink',{attrs:{"tag":"li","to":"/meals"}},[_vm._v("Book a Meal")])],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }